import { Button, Icon } from "@platform/design-system";

export const AddCarrierButton = (): React.JSX.Element => (
  <Button variant="secondary" size="sm" startIcon={<Icon name="add" />}>
    Carrier
  </Button>
);
